function RecordsNotFound() {
    return (
        <>
            <td colSpan={100} className="text-center">
                No record(s) found!
            </td>
        </>
    );
}

export default RecordsNotFound;
